import { createContext } from 'react';

/**
 * Context for the rep dashboard profile click handler.
 * Provided by the chat app when rendering pages inline.
 * When undefined (e.g. in the builder), the arrow button shows but does nothing.
 */
export const RepDashboardProfileClickContext = createContext<
  ((profileId: string, name: string) => void) | undefined
>(undefined);
